import { render, staticRenderFns } from "./shQuestion.vue?vue&type=template&id=7f4baac6&scoped=true&"
import script from "./shQuestion.vue?vue&type=script&lang=js&"
export * from "./shQuestion.vue?vue&type=script&lang=js&"
import style0 from "./shQuestion.vue?vue&type=style&index=0&id=7f4baac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4baac6",
  null
  
)

export default component.exports